import { Input as AntInput, InputProps } from 'antd'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledInput = styled(AntInput.Password)`
  height: 36px;
  box-shadow: none;
  &.non-border:focus {
    border: none;
    border-bottom: 1px solid var(--color-primary-109);
    border-radius: 0;
    box-shadow: none;
  }
  &.non-border {
    border: none;
    border-bottom: 1px solid var(--color-gray-103);
    border-radius: 0;
    padding: 8px 0;
  }
  &.prevent-edit {
    color: inherit;
    background-color: inherit;
  }
`

const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
interface IProps extends InputProps {
  title?: string
  children?: ReactNode
  placeholder?: string
  required?: boolean
  preventInput?: boolean
  hasBorder?: boolean
  value?: string
  visibilityToggle?: any
}

const InputPassword = (props: IProps) => {
  const { t } = useTranslation()
  const {
    title,
    value,
    required,
    placeholder,
    preventInput,
    hasBorder,
    visibilityToggle,
    ...resPros
  } = props
  return (
    <>
      <StyledLabel className="input-label">
        {t(title || '')} {required && <span>*</span>}
      </StyledLabel>
      <StyledInput
        className={`${preventInput ? 'prevent-edit' : ''} ${
          hasBorder ? '' : 'non-border'
        }`}
        placeholder={t(placeholder || '')}
        disabled={preventInput}
        value={value}
        visibilityToggle={visibilityToggle}
        {...resPros}
      />
    </>
  )
}

export default InputPassword
